import React, { Component, View } from 'react';
/**
    * Component is one item in ticker
    * @date 2020-01-14
    */
export default class DataTicker extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <h1><span>{this.props.post.company_name}</span> - {this.props.post.message}</h1>
    );
  }
}
